import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';
import styles from './index.pcss';
import {
  getGstEnhancementFlag,
  getOrderConfirmGstEnhancementTextConfig
} from '../../../../../refresh/selectors/featureFlagsSelector';
import {
  getGstBillingAddress,
  getGstShippingAddress
} from '../../../../../refresh/utils/orderConfirmationUtils';
import { getLuxeFlags } from '../../../../../Flags/selectors';
import { getCurrentStore } from '../../../../../refresh/selectors/metaData';

const cx = classNames.bind(styles);

const AddressCard = ({ title, addr = {}, textConfig = {} }) => {
  const { name = '', address = '', phone = '', gstin = '', gstApplicable = true } = addr;
  return (
    <div className={cx('gst-addr-card')}>
      <div className={cx('gst-addr-title')}>{title}</div>
      <div className={cx('gst-addr-body')}>
        <div className={cx('gst-addr-name-row')}>
          <span className={cx('gst-addr-name')}>{name}</span>
          {gstApplicable ? (
            <span className={cx('gst-addr-badge')}>{textConfig.addressGstLabel}</span>
          ) : (
            <span className={cx('gst-addr-badge', 'gst-addr-badge--na')}>
              {textConfig.gstNonApplicableLabel}
            </span>
          )}
        </div>
        <div className={cx('gst-addr-address')}>{address}</div>
        {phone ? <div className={cx('gst-addr-phone')}>Phone Number: +91 {phone}</div> : null}
        {gstApplicable && gstin ? (
          <div className={cx('gst-addr-gstin')}>
            {textConfig.gstinLabel} {gstin}
          </div>
        ) : null}
      </div>
    </div>
  );
};

const GstAddressSummary = ({
  billingAddress = {},
  shippingAddress = {},
  gstTextConfig = {},
  luxe = false
}) => {
  return (
    <div className={cx('gst-address-summary', { 'luxe-gst-address-summary': luxe })}>
      <AddressCard
        title={gstTextConfig.billingAddressTitle}
        addr={billingAddress}
        textConfig={gstTextConfig}
      />
      <AddressCard
        title={gstTextConfig.shippingAddressTitle}
        addr={shippingAddress}
        textConfig={gstTextConfig}
      />
    </div>
  );
};

const mapStateToProps = state => {
  const order = state?.order || {};
  const { isThemeEnable } = getLuxeFlags(state?.flags);
  const luxe = isThemeEnable === 'ON' && getCurrentStore(state) === 'luxe';
  return {
    enableGstEnhancement: getGstEnhancementFlag(state, 'thankyou'),
    gstTextConfig: getOrderConfirmGstEnhancementTextConfig(state),
    billingAddress: getGstBillingAddress(order),
    shippingAddress: getGstShippingAddress(order),
    luxe
  };
};

export { GstAddressSummary };
export default connect(mapStateToProps)(GstAddressSummary);
